module.exports = __webpack_public_path__ + "img/straciatella_ipad.af51c977.png";